import React from 'react'
import fremm from '../../img/Fram.png';

const One = () => {
  return (
    
    <>
    <div className='container'>
     <div className='row'>
      <div className='col-lg-12 col-sm-12'>
         
      <img src={fremm} alt='#' style={{width:'100%'}}/>
      
      </div>
     </div>
    </div>  
    </>

  )
}

export default One;